import { cn } from '@/lib/utils'
import { Typo3Section } from '@/types/typo3'
import { Container, Richtext, Section } from '@/ui/components'
import { memo } from 'react'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  text?: string
  section?: Typo3Section
  layout?: 'default' | 'wrapped'
}

const SectionText = ({
  text,
  section,
  layout = 'default',
  ...props
}: Props) => {
  if (!text) {
    return null
  }

  return (
    <Section data={section} className="s-section-text py-xl" {...props}>
      <Container
        anim="fade-in"
        size={layout === 'wrapped' ? 'sm-fixed' : undefined}
      >
        <Richtext
          text={text}
          className={cn(
            '[&_p]:gap-gutter',
            layout === 'default' && 'lg:columns-2'
          )}
        />
      </Container>
    </Section>
  )
}

SectionText.displayName = 'SectionText'

export default memo(SectionText)
